module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-us-container"
  }, [_c('h5', [_vm._v("Znajdź nas!")]), _vm._v(" "), _c('div', {
    staticClass: "social-boxes"
  }, [_c('a', {
    staticClass: "social-box",
    attrs: {
      "href": "https://www.facebook.com/Punkta",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-fb"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-box",
    attrs: {
      "href": "https://www.linkedin.com/company/mfind",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-linkedin"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-box",
    attrs: {
      "href": "https://www.wykop.pl/ludzie/mfind/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-wykop"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32d5aa18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/findUs.vue
// module id = 369
// module chunks = 0